import HubspotForm from 'react-hubspot-form';
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { toggleHubspotForm } from '../../state/app';
import XSign from '../../images/X-sign.svg';

const ModalContainer = styled.div`
	align-items: center;
	background-color: rgba(25, 28, 99, 0.42);
	display: flex;
	flex-direction: column;
	height: 100vh;
	justify-content: center;
	left: 0;
	min-height: 100vh;
	position: fixed;
	top: 0;
	width: 100vw;
	z-index: 214748364;
	@media (min-width: 768px) {
		padding: 10% 6%;
	}
	@media (min-width: 1200px) {
		padding: 6%;
	}
`;

const FormWrapper = styled.div`
	background-color: white;
	max-height: 100%;
	overflow-y: auto;
	padding: 60px 20px 120px;
	position: relative;
	width: 100%;
	@media (min-width: 768px) {
		border-radius: 25px;
		padding: 50px 65px;
	}
	@media (min-width: 1440px) {
		width: 1020px;
	}
`;

const XWrapper = styled.div`
	background-image: url(${({ bgXImg }) => bgXImg});
	background-position: center;
	background-size: cover;
	cursor: pointer;
	height: 19px;
	position: absolute;
	right: 25px;
	top: 30px;
	width: 19px;
	@media (min-width: 768px) {
		right: 75px;
		top: 53px;
	}
`;

class HubspotFormModal extends Component {
	render() {
		const { dispatch, currentLocale } = this.props;
		const formId = currentLocale === 'pl' ? 'df2e7c92-b1b0-45e0-bdc1-5dc391d90fdb' : '3bba0717-c104-4afc-bb49-c8fe33795dc6';
		return (
			<ModalContainer>
				<FormWrapper>
					<XWrapper onClick={() => dispatch(toggleHubspotForm(false))} bgXImg={XSign} />
					<HubspotForm
						portalId="7137183"
						formId={formId}
						onSubmit={() => {
							dispatch(toggleHubspotForm(false));
						}}
						onFormSubmitted={() => {
							dispatch(toggleHubspotForm(false));
						}}
						// onReady={form => console.log('Form ready!')}
						// loading={<div>Loading...</div>}m
					/>
				</FormWrapper>
			</ModalContainer>
		);
	}
}

export default connect(
	state => ({
		isHubspotFormVisible: state.app.isHubspotFormVisible,
	}),
	null,
)(HubspotFormModal);
